import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y, filter: "blur(8px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function SectionEyebrow({ index, label, className = "" }) {
    return (
        <div className={cn("flex items-center gap-3 mb-4", className)}>
            <span className="font-mono text-xs text-[#FF2A2A] tracking-[0.28em] uppercase">{index}</span>
            <span className="h-px flex-1 max-w-[64px] bg-white/20" />
            <span className="eyebrow">{label}</span>
        </div>
    );
}

export function SectionHeading({ children, className = "", as: Tag = "h2" }) {
    return (
        <Reveal>
            <Tag className={cn("display-2 text-white text-balance", className)}>{children}</Tag>
        </Reveal>
    );
}
